import React, {useState} from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";
import UserIconNew from "../../../../../../gd-components/icons/user/user";
import {FieldEditableMode} from "../../../../../proto/render/editable";
import {isBulkSelection} from "../../../../../../gd/right-click-menu";


// const debug = "FieldTaskUsers_TableCell"
const debug = false


export default function FieldProjectUsers_TableCell(props: FieldTableCellProps) {


    // STATE & hovered
    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const onMouseEnter = () => {

        if (props.manager.isReadOnly || !props.field.canEdit(props.listItem.project)) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (mode===FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (props.manager.isReadOnly || !props.field.canEdit(props.listItem.project)) return false

        gd.navigation.goToProject(props.listItem.project.id,'/info/users')
    }
    //


    const project       = props.listItem.project
    const usersToShow   = 5;


    let res = [];
    let usersIds = _.map(gd.session.projectUsers.notClients(props.listItem.project.id), projectUser=>projectUser.user.id)

    // sorting
    usersIds = _.orderBy(usersIds, [
        id=>{
            let orderRes = 0;
            const user = project.users ? _.find(project.users, u=>u.id === id) : null;
            if (user) {
                switch (user.role) {
                    case gd.const.project.role.OWNER:           orderRes = 2; break;
                    case gd.const.project.role.PROJECT_MANAGER: orderRes = 1; break;
                }
            }
            return orderRes;
        },
        id=>gd.session.users.get(id)!.name.toLowerCase()
    ], ['desc','asc']);

    const userIcon = (id:ID) =>
        <div key={id} className="ico">
            <UserIconNew className="user-icon" size="22" hint="up" userId={id} blackWhite={project.isClosed}/>
        </div>

    if (usersIds.length > usersToShow) {
        usersIds.map(userId=>{
            if (res.length < (usersToShow-1)) res.push(userIcon(userId));
        });

        res.push(
            <div key="more" className="ico">
                <div className="ui5-counter circle-user">+{usersIds.length - (usersToShow-1)}</div>
            </div>
        )
    } else {
        usersIds.map(userId=>{res.push(userIcon(userId));});
    }


    // PAtch - no users for tempalte
    if (project.isTemplate) res = []

    const classes = Classes("ui5-field-editable size-small w-100-percent h-100-percent", {
        "is-hovered"            : mode === FieldEditableMode.HOVERED
    })

    return (
        <div className={Classes("cell-flex", props.className, "is-hovered")} style={getTableCellStyle(props)} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick}>
            <div className={classes}>
                <div className="ui5-users-group txt-truncate">{res}</div>
            </div>
        </div>
    )
}



